import LocalizationConstants from "src/app/constants/localization-constants";

// Actual Salesforce values
export enum TechCoverTicketPriority {
  Lowest = "Lowest",
  Low = "Low",
  Medium = "Medium",
  High = "High",
  Highest = "Highest",
}

export type TechCoverTicketPriorityOption = {
  value: TechCoverTicketPriority;
  label: string;
};

export const TechCoverTicketPriorityOptions: TechCoverTicketPriorityOption[] = [
  {
    value: TechCoverTicketPriority.Lowest,
    label: LocalizationConstants.TECH_COVER_TICKET_PRIORITY_LOWEST,
  },
  {
    value: TechCoverTicketPriority.Low,
    label: LocalizationConstants.TECH_COVER_TICKET_PRIORITY_LOW,
  },
  {
    value: TechCoverTicketPriority.Medium,
    label: LocalizationConstants.TECH_COVER_TICKET_PRIORITY_MEDIUM,
  },
  {
    value: TechCoverTicketPriority.High,
    label: LocalizationConstants.TECH_COVER_TICKET_PRIORITY_HIGH,
  },
  {
    value: TechCoverTicketPriority.Highest,
    label: LocalizationConstants.TECH_COVER_TICKET_PRIORITY_HIGHEST,
  },
];
